import React from 'react'
import Sidebar from '../../Components/sideBar'

function ApplicationsReceived() {
  return (
    <h1>
      Applications received
    </h1>
  )
}

export default ApplicationsReceived
